import { createReducer, on } from '@ngrx/store';

import { myReportListResponse } from './my-report.actions';
import { MyReportListPagination } from '../../models/my-report';

export interface MyReportState {
  isSuccess: boolean;
  totalElements: number;
  totalPages: number;
  reportList: MyReportListPagination;
}

export const initialState: MyReportState = {
  isSuccess: null,
  totalElements: null,
  totalPages: null,
  reportList: null
};

export const myReportReducer = createReducer<MyReportState>(
  initialState,
  on(myReportListResponse, (state, { data }) => ({
    ...state,
    reportList: data
  }))
);
